import { Component } from 'react';
import AccountSettingsDropdown from './accountSettingsDropdown'
import FontAwesome from 'react-fontawesome';
import HeaderLogo from './headerLogo';

class HeaderMobile extends Component {

    handleButtonClick(action) {
        if (this.props.buttonHandler && this.props.appInitialized) {
            this.props.buttonHandler(action)
        }
    }

    handleLangClick(lang) {
        if (this.props.langHandler) {
            this.props.langHandler(lang)
        }
    }

    renderMainBar() {
        var headerButtons = [];
        if (this.props.loginComplete) {
            headerButtons.push(
                <div key='signOutButton' className="headerButtonStyle headerButtonMarginMobile"
                    onClick={(ev) => { this.handleButtonClick('logout') }}>
                    <FontAwesome className='fa-sign-out' name='fa-sign-out' size='lg' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', color: '#14AA40', align: 'center' }} />
                </div>
            )
        } else {
            var headerStyle = "headerButtonStyle headerButtonMarginMobile"
            if (!this.props.appInitialized) {
                headerStyle += " uninitialized"
            }
            headerButtons.push(
                <div key='signInButton' className={headerStyle}
                    onClick={(ev) => { this.handleButtonClick('login') }}>
                    <FontAwesome className='fa-user' name='fa-user' size='lg' style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0)', align: 'center' }} />
                </div>
            )
        }

        var enLangButtonStyle = 'languageButton'
        var frLangButtonStyle = 'languageButton'
        if (this.props.lang === 'fr') {
            enLangButtonStyle += ' unselected'
            frLangButtonStyle += ' selected'
        } else {
            enLangButtonStyle += ' selected'
            frLangButtonStyle += ' unselected'
        }
        return (
            <div className='headerContainerWF'>
                <HeaderLogo height='28px' width='161px' darkText onClick={() => this.handleButtonClick('home')} layoutType={this.props.layoutType} loaded={this.props.loaded} />
                <div className="headerRight mobileMarginRight">
                    {this.props.loaded &&
                        <AccountSettingsDropdown 
                            lang={this.props.lang} 
                            langHandler={this.props.langHandler} 
                            loginComplete={this.props.loginComplete}
                            handleButtonClick={this.handleButtonClick.bind(this)}
                            pathname={this.props.pathname}
                            layoutType={this.props.layoutType} />}
                </div>
            </div>    
        )
    }

    render() {
        return (
            <div className='headerStyleWF'>
                {this.renderMainBar()}
            </div>
        )
    }
}

export default HeaderMobile;